import type { Category, CategoryInput } from '@shop-monorepo/types';
import { Button, Form, Input, Select, Switch } from 'antd';
import React from 'react';

interface CategoryFormProps {
  initialValues?: Partial<CategoryInput>;
  onSubmit: (values: CategoryInput) => Promise<void>;
  isSubmitting: boolean;
  parentCategories: Category[];
  disableParentSelect?: boolean;
}

export const CategoryForm: React.FC<CategoryFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting,
  parentCategories,
  disableParentSelect = false,
}) => {
  const [form] = Form.useForm();
  const parentId = Form.useWatch('parentId', form);

  const handleFinish = async (values: CategoryInput) => {
    await onSubmit(values);
    form.resetFields();
  };

  const currentCategoryId = (initialValues as Category)?.id;

  const parentOptions = [
    { value: null, label: 'Немає (коренева категорія)' },
    ...parentCategories
      .filter((cat) => cat.id !== currentCategoryId)
      .map((cat) => ({
        value: cat.id,
        label: cat.name,
      })),
  ];

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={initialValues}>
      <Form.Item
        name="name"
        label="Назва"
        rules={[{ required: true, message: 'Будь ласка, введіть назву категорії' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="parentId"
        label="Батьківська категорія"
        tooltip={disableParentSelect ? 'Неможливо змінити, категорія має підкатегорії' : undefined}
      >
        <Select
          options={parentOptions}
          disabled={disableParentSelect}
          placeholder="Оберіть батьківську категорію"
        />
      </Form.Item>
      {!parentId && (
        <Form.Item name="icon" label="Іконка (SVG)">
          <Input.TextArea
            rows={5}
            placeholder={'<svg xmlns="http://www.w3.org/2000/svg" ...>...</svg>'}
          />
        </Form.Item>
      )}
      <Form.Item name="isActive" label="Активна" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isSubmitting}>
          Зберегти
        </Button>
      </Form.Item>
    </Form>
  );
};
